import React, {ReactNode} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';

interface FeatureProps {
    children: ReactNode;
    fallbackComponent?: ReactNode;
}

export const FeatureFlags = ({children, fallbackComponent}: FeatureProps) => {
    const BgMSAllowed = [
        'manu.jha1994@gmail.com',
        'explorer@perceptpixel.com',
        'signature@perceptpixel.com',
        'kaushik.mk@perceptinsight.com',
        'testdash@gmail.com',
        'kaushik.mk@udaan.com',
        'kaushik@perceptpixel.com',
        'perceptpixel@gmail.com',
        'trial@perceptpixel.com',
        'pratik4327@gmail.com',
    ];

    const userProfileProps = useSelector((state: RootState) => state.userProfile);
    const userEmail = userProfileProps.email;

    const isAllowed = BgMSAllowed.includes(userEmail) || userEmail.endsWith('@perceptinsight.com');

    return (
        <>
            {isAllowed ? (
                <div>{children}</div>
            ) : (
                <div>{fallbackComponent !== undefined ? fallbackComponent : null}</div>
            )}
        </>
    );
};
